import script from "./PriceSuffix.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceSuffix.vue?vue&type=script&setup=true&lang=js"

import "./PriceSuffix.vue?vue&type=style&index=0&id=81e7692c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81e7692c"]])

export default __exports__